module.exports = __webpack_public_path__ + "static/media/single-iphone.8e3ca996.png";